import { ProtocolContentData } from "../../protocol";
export default class TugReleasedData extends ProtocolContentData {
    name;
    freeText;
    constructor(name, freeText) {
        super();
        this.name = name;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=TugReleasedData.js.map